// extracted by mini-css-extract-plugin
export var buttonContainer = "_9n-1";
export var fontSizeSelect = "_9n-3";
export var formatSelect = "_9n-2";
export var formats = "_9n-4";
export var hidden = "_9n-5";
export var icon = "_9n-6";
export var select = "_9n-0";